import React from 'react';
import { SubDrawerData } from '../../../types/Drawer';
import DocumentIcon from '../../../assests/icons/doc.svg';
import credentialsIcon from '../../../assests/icons/credentials.svg';
import webhooksIcon from '../../../assests/icons/webhooks.png';
import statusPageIcon from '../../../assests/icons/statusPage.png';
import usersIcon from '../../../assests/icons/users.png';
import rolesIcon from '../../../assests/icons/roles.png';
import usageIcon from '../../../assests/icons/usage.png';
import invoicesIcon from '../../../assests/icons/invoices.png';
import paymentMethodsIcon from '../../../assests/icons/paymentMethods.png';
import businessInfoIcon from '../../../assests/icons/businessInfo.png';
import personalInfoIcon from '../../../assests/icons/personalInfo.png';
import businessMetricsIcon from '../../../assests/icons/business_metrics.svg';
import logoutIcon from '../../../assests/icons/logout.svg';

const analyticsSubDrawerConfig: SubDrawerData = {
  parentId: 'drawer__menu_analytics',
  title: 'Analytics',
  defaultTab: 'businessMetrics',
  groups: [
    {
      id: 'drawer__menu_analytics_performance',
      title: 'Performance',
      items: [
        {
          key: 'businessMetrics',
          text: 'Business Metrics',
          onClickFunctionName: 'businessMetrics',
          icon: <img src={businessMetricsIcon} alt="businessMetrics" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_analytics_performance_businessMetrics',
        },
        {
          key: 'stepwiseAnalytics',
          text: 'Stepwise Analytics',
          onClickFunctionName: 'stepwiseAnalytics',
          icon: <img src={businessMetricsIcon} alt="stepwiseAnalytics" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_analytics_performance_stepwiseAnalytics',
        },
      ],
    },
  ],
};

const accountSubDrawerConfig: SubDrawerData = {
  parentId: 'drawer__menu_account',
  title: 'Account',
  defaultTab: 'usage',
  groups: [
    {
      id: 'drawer__menu_account_team',
      title: 'Team',
      items: [
        {
          key: 'users',
          text: 'Users',
          onClickFunctionName: 'users',
          icon: <img src={usersIcon} alt="users" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_account_team_users',
        },
        {
          key: 'roles',
          text: 'Roles',
          onClickFunctionName: 'roles',
          icon: <img src={rolesIcon} alt="roles" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_account_team_roles',
        },
      ],
    },
    {
      id: 'drawer__menu_account_billing',
      title: 'Billing',
      items: [
        {
          key: 'usage',
          text: 'Usage',
          onClickFunctionName: 'usage',
          icon: <img src={usageIcon} alt="usage" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_account_billing_usage',
        },
        {
          key: 'invoices',
          text: 'Invoices',
          onClickFunctionName: 'invoices',
          icon: <img src={invoicesIcon} alt="invoices" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_account_billing_invoices',
        },
        {
          key: 'paymentMethods',
          text: 'Payment Methods',
          onClickFunctionName: 'paymentMethods',
          icon: <img src={paymentMethodsIcon} alt="paymentMethods" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_account_billing_payment_methods',
        },
      ],
    },
    {
      id: 'drawer__menu_account_company',
      title: 'Company',
      items: [
        {
          key: 'businessInfo',
          text: 'Business Info',
          onClickFunctionName: 'businessInfo',
          icon: <img src={businessInfoIcon} alt="businessInfo" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_account_company_business_information',
        },
      ],
    },
    {
      id: 'drawer__menu_account_profile',
      title: 'Your profile',
      items: [
        {
          key: 'personalInfo',
          text: 'Personal Info',
          onClickFunctionName: 'personalinfo',
          icon: <img src={personalInfoIcon} alt="personalinfo" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_account_profile_personal_info',
        },
        {
          key: 'logout',
          text: 'Log Out',
          onClickFunctionName: 'logout',
          icon: <img src={logoutIcon} alt="logout" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_account_profile_logout',
        },
      ],
    },
  ],
};

const devHubSubDrawerConfig: SubDrawerData = {
  parentId: 'drawer__menu_dev_hub',
  title: 'Dev Hub',
  defaultTab: 'credentials',
  groups: [
    {
      id: 'drawer__menu_dev_hub_integrate_group',
      title: 'Integrate',
      items: [
        {
          key: 'documentation',
          text: 'Documentation',
          onClickFunctionName: 'documentation',
          icon: <img src={DocumentIcon} alt="" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_dev_hub_integrate_documentation',
          external: true,
        },
        {
          key: 'credentials',
          text: 'Credentials',
          onClickFunctionName: 'credentials',
          icon: <img src={credentialsIcon} alt="" />,
          disabled: false,
          hidden: false,
          id: 'drawer__menu_dev_hub_integrate_credentials',
        },
        {
          key: 'webhooks',
          text: 'Webhooks',
          onClickFunctionName: 'webhooks',
          icon: <img src={webhooksIcon} alt="" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_dev_hub_integrate_webhooks',
        },
      ],
    },
    {
      id: 'drawer__menu_dev_hub_monitor_group',
      title: 'Monitor',
      items: [
        {
          key: 'statusPage',
          text: 'Status Page',
          onClickFunctionName: 'statusPage',
          icon: <img src={statusPageIcon} alt="" />,
          disabled: true,
          hidden: false,
          id: 'drawer__menu_dev_hub_monitor_status_page',
        },
      ],
    },
  ],
};

const configMap: Record<string, SubDrawerData> = {
  account: accountSubDrawerConfig,
  devHub: devHubSubDrawerConfig,
  analytics: analyticsSubDrawerConfig,
};

export const subDrawerInitialState: SubDrawerData = {
  parentId: '',
  title: '',
  defaultTab: '',
  groups: [],
};

export default configMap;
